module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-row', {
    staticClass: "submit-post-payout pa-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "card-box"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.isCurrentUser && !_vm.isNotInfluencer) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.isCampaign) ? _c('v-text-field', {
    attrs: {
      "label": "Campaign Name",
      "filled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaignPayout.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "campaignName", $$v)
      },
      expression: "campaignPayout.campaignName"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Select Campaign",
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": _vm.changeCampaign
    },
    model: {
      value: (_vm.campaignPayout.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "campaignID", $$v)
      },
      expression: "campaignPayout.campaignID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isCurrentUser || _vm.isNotInfluencer) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Campaign Name")]), _vm._v(": \n                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.campaignPayout.campaignName))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Creator Handle")]), _vm._v(": \n                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.campaignPayout.fullName) + " (" + _vm._s(_vm.campaignPayout.handle) + ")")])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.isStoryTell && _vm.deliverables) ? _c('div', {
    staticClass: "deliverables"
  }, [_vm._v("\n                Your deliverables for this campaign:\n                "), _c('post-deliverables', {
    attrs: {
      "deliverables": _vm.deliverables
    }
  })], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), (_vm.campaignPayout.campaignID) ? _c('div', {
    staticClass: "card-box"
  }, [_c('v-stepper', {
    model: {
      value: (_vm.mainStep),
      callback: function($$v) {
        _vm.mainStep = $$v
      },
      expression: "mainStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.mainStep > 1
    }
  }, [_vm._v("Stats submission & Ratings")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.mainStep > 2
    }
  }, [_vm._v("Feedback Questions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Others")])], 1), _vm._v(" "), _c('v-stepper-items', {
    staticClass: "stepper-items"
  }, [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 1
    }
  }, [(_vm.firstSteppers.length) ? _c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.firstActiveStep),
      callback: function($$v) {
        _vm.firstActiveStep = $$v
      },
      expression: "firstActiveStep"
    }
  }, _vm._l((_vm.firstSteppers), function(step, stepIndex) {
    return _c('div', {
      key: stepIndex
    }, [_c('span', {
      staticClass: "d-none"
    }, [_vm._v(_vm._s(stepIndex))]), _vm._v(" "), (step.type === 'storyCoverage') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    Upload your coverage and statistics for IG Story(ies)\n                    "), _c('v-btn', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "text": "",
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.showPayoutSampleDialog('igStory')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "center": "",
        "small": ""
      }
    }, [_vm._v("mdi-newspaper")]), _vm._v(" View stats required here\n                    ")], 1)], 1) : _vm._e(), _vm._v(" "), (step.type === 'storyCoverage') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_vm._l((_vm.campaignPayout.stories), function(story, index) {
      return _c('v-card', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "flat": ""
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "label",
          "hint": "label IGS 1, IGS 2 etc for multiple stories",
          "persistent-hint": "",
          "outlined": "",
          "dense": ""
        },
        scopedSlots: _vm._u([{
          key: "append-outer",
          fn: function() {
            return [_c('v-btn', {
              staticStyle: {
                "margin-top": "-6px"
              },
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deletePostGroup(_vm.campaignPayout.stories, index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (story.label),
          callback: function($$v) {
            _vm.$set(story, "label", $$v)
          },
          expression: "story.label"
        }
      }), _vm._v(" "), _c('v-row', {
        staticClass: "mb-5"
      }, [_vm._l((story.showImages), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.thumbnail,
                  "lazy-src": img.thumbnail,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteCustomImage(story, imgIndex)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), _vm._v(" "), _c('v-col', {
        staticClass: "d-flex child-flex img-box",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      }, [_c('v-card', {
        staticClass: "d-flex",
        staticStyle: {
          "height": "100%"
        },
        attrs: {
          "outlined": "",
          "flat": "",
          "tile": ""
        },
        on: {
          "click": function($event) {
            return _vm.showFileUploader('storyUpload' + index)
          }
        }
      }, [_c('v-btn', {
        staticClass: "ma-auto",
        attrs: {
          "dark": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
        ref: 'storyUpload' + index,
        refInFor: true,
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "name": "images",
          "id": 'storyUpload' + index,
          "accept": "image/*, video/*"
        },
        on: {
          "change": function($event) {
            return _vm.prepareCustomUpload($event, story)
          }
        }
      })], 1)], 1)], 1)], 2)], 1)
    }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.addMore('stories')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      }
    }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (step.type === 'postURL') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    Enter the URL to your in-feed content here\n                    ")]) : _vm._e(), _vm._v(" "), (step.type === 'postURL') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_vm._l((_vm.campaignPayout.posts), function(post, index) {
      return _c('v-card', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "flat": ""
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Post URL",
          "outlined": "",
          "dense": ""
        },
        scopedSlots: _vm._u([{
          key: "append-outer",
          fn: function() {
            return [_c('v-btn', {
              staticStyle: {
                "margin-top": "-6px"
              },
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deletePostGroup(_vm.campaignPayout.posts, index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (post.instagramPostURL),
          callback: function($$v) {
            _vm.$set(post, "instagramPostURL", $$v)
          },
          expression: "post.instagramPostURL"
        }
      }), _vm._v(" "), _c('v-row', {
        staticClass: "mb-2"
      }, [_vm._l((post.showImages), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.thumbnail,
                  "lazy-src": img.thumbnail,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteCustomImage(post, imgIndex)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), _vm._v(" "), _c('v-col', {
        staticClass: "d-flex child-flex img-box",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      }, [_c('v-card', {
        staticClass: "d-flex",
        staticStyle: {
          "height": "100%"
        },
        attrs: {
          "outlined": "",
          "flat": "",
          "tile": ""
        },
        on: {
          "click": function($event) {
            return _vm.showFileUploader('mediaUpload' + index)
          }
        }
      }, [_c('v-btn', {
        staticClass: "ma-auto",
        attrs: {
          "dark": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
        ref: 'mediaUpload' + index,
        refInFor: true,
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "name": "images",
          "id": 'mediaUpload' + index,
          "accept": "image/*, video/*"
        },
        on: {
          "change": function($event) {
            return _vm.prepareCustomUpload($event, post)
          }
        }
      })], 1)], 1)], 1)], 2)], 1)
    }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.addMore('posts')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      }
    }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (step.type === 'deliverable') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDeliverablePost(step.fields.name).title) + "\n                    "), (_vm.getDeliverablePost(step.fields.name).sampleType !== 'custom' && _vm.getDeliverablePost(step.fields.name).sampleType !== 'youtube') ? _c('v-btn', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "text": "",
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.showPayoutSampleDialog(_vm.getDeliverablePost(step.fields.name).sampleType)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "center": "",
        "small": ""
      }
    }, [_vm._v("mdi-newspaper")]), _vm._v(" View stats required here\n                    ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (step.type === 'deliverable') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, _vm._l((_vm.campaignPayout.deliverablePosts), function(allPost, contentIndex) {
      return _c('div', {
        key: contentIndex
      }, [(allPost.type === step.fields.name) ? _c('div', [_vm._l((_vm.campaignPayout.deliverablePosts[contentIndex].posts), function(post, index) {
        return _c('v-card', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": _vm.getLabel(step.fields.name),
            "hide-details": "",
            "outlined": "",
            "dense": ""
          },
          scopedSlots: _vm._u([{
            key: "append-outer",
            fn: function() {
              return [_c('v-btn', {
                staticStyle: {
                  "margin-top": "-6px"
                },
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deletePostGroup(_vm.campaignPayout.deliverablePosts[contentIndex].posts, index)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)]
            },
            proxy: true
          }], null, true),
          model: {
            value: (post.label),
            callback: function($$v) {
              _vm.$set(post, "label", $$v)
            },
            expression: "post.label"
          }
        }), _vm._v(" "), (!_vm.campaignPayout.deliverablePosts[contentIndex].posts[index].label) ? _c('p', {
          staticClass: "text-danger"
        }, [_vm._v("This field is required")]) : _vm._e(), _vm._v(" "), _c('v-row', {
          staticClass: "mb-5 mt-2"
        }, [_vm._l((post.showImages), function(img, imgIndex) {
          return _c('v-col', {
            key: imgIndex,
            staticClass: "d-flex child-flex img-box",
            attrs: {
              "cols": "4"
            }
          }, [_c('v-hover', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(ref) {
                var hover = ref.hover;

                return [_c('v-card', {
                  staticClass: "d-flex",
                  attrs: {
                    "flat": "",
                    "tile": "",
                    "elevation": hover ? 16 : 2
                  }
                }, [(_vm.isVideo(img.thumbnail)) ? _c('video', {
                  attrs: {
                    "src": img.thumbnail,
                    "controls": ""
                  }
                }, [_vm._v("             \n                                      Your browser does not support the video tag.\n                                  ")]) : _vm._e(), _vm._v(" "), _c('v-img', {
                  staticClass: "grey lighten-2",
                  attrs: {
                    "src": img.thumbnail,
                    "lazy-src": img.thumbnail,
                    "aspect-ratio": "1"
                  }
                }), _vm._v(" "), _c('v-overlay', {
                  attrs: {
                    "absolute": ""
                  }
                }, [_c('v-btn', {
                  attrs: {
                    "dark": "",
                    "icon": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.deleteCustomImage(post, imgIndex)
                    }
                  }
                }, [_c('v-icon', {
                  attrs: {
                    "dark": "",
                    "color": "red"
                  }
                }, [_vm._v("cancel")])], 1)], 1)], 1)]
              }
            }], null, true)
          })], 1)
        }), _vm._v(" "), _c('v-col', {
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1
          }
        }, [_c('v-card', {
          staticClass: "d-flex",
          staticStyle: {
            "height": "100%"
          },
          attrs: {
            "outlined": "",
            "flat": "",
            "tile": ""
          },
          on: {
            "click": function($event) {
              return _vm.showFileUploader('deliverableUpload' + contentIndex + index)
            }
          }
        }, [_c('v-btn', {
          staticClass: "ma-auto",
          attrs: {
            "dark": "",
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "color": "primary"
          }
        }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
          ref: 'deliverableUpload' + contentIndex + index,
          refInFor: true,
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "name": "images",
            "id": 'deliverableUpload' + contentIndex + index,
            "accept": "image/*, video/*"
          },
          on: {
            "change": function($event) {
              return _vm.prepareCustomUpload($event, post)
            }
          }
        })], 1)], 1)], 1)], 2), _vm._v(" "), (!post.showImages.length) ? _c('p', {
          staticClass: "text-danger mb-5",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("This field is required")]) : _vm._e()], 1)
      }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
        attrs: {
          "color": "secondary",
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addMore('deliverables', contentIndex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
        attrs: {
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            _vm.firstActiveStep = stepIndex + 2
          }
        }
      }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (step.type === 'advertiserSatisfactionLevel') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    How would you rate your overall experience with the client?\n                  ")]) : _vm._e(), _vm._v(" "), (step.type === 'advertiserSatisfactionLevel') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_c('v-rating', {
      staticClass: "mb-5",
      attrs: {
        "size": "30",
        "dense": "",
        "color": "secondary"
      },
      on: {
        "input": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      },
      model: {
        value: (_vm.campaignPayout.advertiserSatisfactionLevel),
        callback: function($$v) {
          _vm.$set(_vm.campaignPayout, "advertiserSatisfactionLevel", $$v)
        },
        expression: "campaignPayout.advertiserSatisfactionLevel"
      }
    })], 1) : _vm._e(), _vm._v(" "), (step.type === 'kobeSatisfactionLevel') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    How would you rate your overall experience with Kobe?\n                  ")]) : _vm._e(), _vm._v(" "), (step.type === 'kobeSatisfactionLevel') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_c('v-rating', {
      staticClass: "mb-5",
      attrs: {
        "size": "30",
        "dense": "",
        "color": "secondary"
      },
      on: {
        "input": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      },
      model: {
        value: (_vm.campaignPayout.kobeSatisfactionLevel),
        callback: function($$v) {
          _vm.$set(_vm.campaignPayout, "kobeSatisfactionLevel", $$v)
        },
        expression: "campaignPayout.kobeSatisfactionLevel"
      }
    })], 1) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.proceedStepTwo
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 2
    }
  }, [_c('p', {
    staticClass: "body-2 pa-3 pt-5 pb-0"
  }, [_vm._v("The questions below will allow us to share on behalf your experience and feedback, during the review meeting with the clients:")]), _vm._v(" "), _c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.secondActiveStep),
      callback: function($$v) {
        _vm.secondActiveStep = $$v
      },
      expression: "secondActiveStep"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.secondActiveStep > 1,
      "step": "1"
    }
  }, [_vm._v("\n                  What do you like most about this product/service you are promoting? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.promotingProducts),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "promotingProducts", $$v)
      },
      expression: "campaignPayout.promotingProducts"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.campaignPayout.promotingProducts
    },
    on: {
      "click": function($event) {
        _vm.secondActiveStep = 2
      }
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.secondActiveStep > 2,
      "step": "2"
    }
  }, [_vm._v("\n                  What are areas of improvement about this product/service that will be valuable feedback for them? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.improved),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "improved", $$v)
      },
      expression: "campaignPayout.improved"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.campaignPayout.improved
    },
    on: {
      "click": function($event) {
        _vm.secondActiveStep = 3
      }
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "3"
    }
  }, [_vm._v("\n                  What do you think your audience enjoyed about your content? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.audienceEnjoyment),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "audienceEnjoyment", $$v)
      },
      expression: "campaignPayout.audienceEnjoyment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 1
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n                    Back\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.disableStepTwo
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 3
      }
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 3
    }
  }, [_c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.thirdActiveStep),
      callback: function($$v) {
        _vm.thirdActiveStep = $$v
      },
      expression: "thirdActiveStep"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.thirdActiveStep > 1,
      "step": "1"
    }
  }, [_vm._v("\n                  What other campaigns would you want to work more on with us?\n                ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "body-2 mt-2 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.otherCampaigns),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "otherCampaigns", $$v)
      },
      expression: "campaignPayout.otherCampaigns"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.thirdActiveStep = 2
      }
    }
  }, [_vm._v("Continue")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "2"
    }
  }, [_vm._v("\n                  Upload Invoice for agencies (optional)\n                ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "body-2 mt-2 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateMedias
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 2
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n                    Back\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.createCampaignPayout
    }
  }, [_vm._v("Submit Payout")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('payout-sample-modal', {
    attrs: {
      "type": _vm.sampleType
    },
    model: {
      value: (_vm.payoutSampleDialog),
      callback: function($$v) {
        _vm.payoutSampleDialog = $$v
      },
      expression: "payoutSampleDialog"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a277cfd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/SubmitPostPayout.vue
// module id = 2141
// module chunks = 0